/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListViewCustomQuickFiltersQueryVariables = Types.Exact<{
  listViewName: Types.Scalars['String']['input'];
}>;


export type ListViewCustomQuickFiltersQuery = { viewerQuickFilters: Array<{ __typename: 'ViewerQuickFilter', id: string, listViewName: string, filterName: string, filterValue: any }> };

export type AddListViewCustomQuickFilterMutationVariables = Types.Exact<{
  input: Types.AddViewerQuickFilterInput;
}>;


export type AddListViewCustomQuickFilterMutation = { addViewerQuickFilter: { __typename: 'ViewerQuickFilter', id: string, listViewName: string, filterName: string, filterValue: any } };

export type RemoveListViewCustomQuickFilterMutationVariables = Types.Exact<{
  input: Types.RemoveViewerQuickFilterInput;
}>;


export type RemoveListViewCustomQuickFilterMutation = { removeViewerQuickFilter: { __typename: 'RemoveViewerQuickFilterResult', success: boolean } };

export type RenameListViewCustomQuickFilterMutationVariables = Types.Exact<{
  input: Types.RenameViewerQuickFilterInput;
}>;


export type RenameListViewCustomQuickFilterMutation = { renameViewerQuickFilter: { __typename: 'ViewerQuickFilter', id: string, listViewName: string, filterName: string, filterValue: any } };


export const ListViewCustomQuickFiltersDocument = gql`
    query ListViewCustomQuickFilters($listViewName: String!) {
  viewerQuickFilters(listViewName: $listViewName) {
    id
    listViewName
    filterName
    filterValue
  }
}
    `;

/**
 * __useListViewCustomQuickFiltersQuery__
 *
 * To run a query within a React component, call `useListViewCustomQuickFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListViewCustomQuickFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListViewCustomQuickFiltersQuery({
 *   variables: {
 *      listViewName: // value for 'listViewName'
 *   },
 * });
 */
export function useListViewCustomQuickFiltersQuery(baseOptions: Apollo.QueryHookOptions<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables> & ({ variables: ListViewCustomQuickFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>(ListViewCustomQuickFiltersDocument, options);
      }
export function useListViewCustomQuickFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>(ListViewCustomQuickFiltersDocument, options);
        }
export function useListViewCustomQuickFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>(ListViewCustomQuickFiltersDocument, options);
        }
export type ListViewCustomQuickFiltersQueryHookResult = ReturnType<typeof useListViewCustomQuickFiltersQuery>;
export type ListViewCustomQuickFiltersLazyQueryHookResult = ReturnType<typeof useListViewCustomQuickFiltersLazyQuery>;
export type ListViewCustomQuickFiltersSuspenseQueryHookResult = ReturnType<typeof useListViewCustomQuickFiltersSuspenseQuery>;
export type ListViewCustomQuickFiltersQueryResult = Apollo.QueryResult<ListViewCustomQuickFiltersQuery, ListViewCustomQuickFiltersQueryVariables>;
export const AddListViewCustomQuickFilterDocument = gql`
    mutation AddListViewCustomQuickFilter($input: AddViewerQuickFilterInput!) {
  addViewerQuickFilter(input: $input) {
    id
    listViewName
    filterName
    filterValue
  }
}
    `;
export type AddListViewCustomQuickFilterMutationFn = Apollo.MutationFunction<AddListViewCustomQuickFilterMutation, AddListViewCustomQuickFilterMutationVariables>;

/**
 * __useAddListViewCustomQuickFilterMutation__
 *
 * To run a mutation, you first call `useAddListViewCustomQuickFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddListViewCustomQuickFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addListViewCustomQuickFilterMutation, { data, loading, error }] = useAddListViewCustomQuickFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddListViewCustomQuickFilterMutation(baseOptions?: Apollo.MutationHookOptions<AddListViewCustomQuickFilterMutation, AddListViewCustomQuickFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddListViewCustomQuickFilterMutation, AddListViewCustomQuickFilterMutationVariables>(AddListViewCustomQuickFilterDocument, options);
      }
export type AddListViewCustomQuickFilterMutationHookResult = ReturnType<typeof useAddListViewCustomQuickFilterMutation>;
export type AddListViewCustomQuickFilterMutationResult = Apollo.MutationResult<AddListViewCustomQuickFilterMutation>;
export type AddListViewCustomQuickFilterMutationOptions = Apollo.BaseMutationOptions<AddListViewCustomQuickFilterMutation, AddListViewCustomQuickFilterMutationVariables>;
export const RemoveListViewCustomQuickFilterDocument = gql`
    mutation RemoveListViewCustomQuickFilter($input: RemoveViewerQuickFilterInput!) {
  removeViewerQuickFilter(input: $input) {
    success
  }
}
    `;
export type RemoveListViewCustomQuickFilterMutationFn = Apollo.MutationFunction<RemoveListViewCustomQuickFilterMutation, RemoveListViewCustomQuickFilterMutationVariables>;

/**
 * __useRemoveListViewCustomQuickFilterMutation__
 *
 * To run a mutation, you first call `useRemoveListViewCustomQuickFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveListViewCustomQuickFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeListViewCustomQuickFilterMutation, { data, loading, error }] = useRemoveListViewCustomQuickFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveListViewCustomQuickFilterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveListViewCustomQuickFilterMutation, RemoveListViewCustomQuickFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveListViewCustomQuickFilterMutation, RemoveListViewCustomQuickFilterMutationVariables>(RemoveListViewCustomQuickFilterDocument, options);
      }
export type RemoveListViewCustomQuickFilterMutationHookResult = ReturnType<typeof useRemoveListViewCustomQuickFilterMutation>;
export type RemoveListViewCustomQuickFilterMutationResult = Apollo.MutationResult<RemoveListViewCustomQuickFilterMutation>;
export type RemoveListViewCustomQuickFilterMutationOptions = Apollo.BaseMutationOptions<RemoveListViewCustomQuickFilterMutation, RemoveListViewCustomQuickFilterMutationVariables>;
export const RenameListViewCustomQuickFilterDocument = gql`
    mutation RenameListViewCustomQuickFilter($input: RenameViewerQuickFilterInput!) {
  renameViewerQuickFilter(input: $input) {
    id
    listViewName
    filterName
    filterValue
  }
}
    `;
export type RenameListViewCustomQuickFilterMutationFn = Apollo.MutationFunction<RenameListViewCustomQuickFilterMutation, RenameListViewCustomQuickFilterMutationVariables>;

/**
 * __useRenameListViewCustomQuickFilterMutation__
 *
 * To run a mutation, you first call `useRenameListViewCustomQuickFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameListViewCustomQuickFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameListViewCustomQuickFilterMutation, { data, loading, error }] = useRenameListViewCustomQuickFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameListViewCustomQuickFilterMutation(baseOptions?: Apollo.MutationHookOptions<RenameListViewCustomQuickFilterMutation, RenameListViewCustomQuickFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameListViewCustomQuickFilterMutation, RenameListViewCustomQuickFilterMutationVariables>(RenameListViewCustomQuickFilterDocument, options);
      }
export type RenameListViewCustomQuickFilterMutationHookResult = ReturnType<typeof useRenameListViewCustomQuickFilterMutation>;
export type RenameListViewCustomQuickFilterMutationResult = Apollo.MutationResult<RenameListViewCustomQuickFilterMutation>;
export type RenameListViewCustomQuickFilterMutationOptions = Apollo.BaseMutationOptions<RenameListViewCustomQuickFilterMutation, RenameListViewCustomQuickFilterMutationVariables>;